import { isMember } from "../utils"

export const Navbar = () => <div class="venue-navbar-wrapper">
	<div class="topnavtk2 left-nav" id="myTopnavtk2">
		<a href="https://isfcongress.tkeventsregistration.com/digital2021" id="LeaveEvent" class="activetk2">Leave Event</a>
		{
			isMember && <>
				<div class="dropdowntk2">
					<button class="dropbtntk2">Schedule
						<i class="fa fa-caret-down" />
					</button>
					<div class="dropdown-contenttk2">
						<a href="https://isfcongress.tkeventsregistration.com/digital2021/personalschedule" title="Personal Agenda">Personal Agenda</a>
						<a href="https://isfcongress.tkeventsregistration.com/digital2021/fullschedule" title="Full Schedule">Full Schedule</a>
					</div>
				</div>
			</>
		}
		<a href="/atrium" title="Atrium">Atrium</a>
		<div class="dropdowntk2">
			<button class="dropbtntk2">Room Navigation
				<i class="fa fa-caret-down" />
			</button>
			<div class="dropdown-contenttk2">
				<a href="/exhibition-hall" title="Exhibition Hall">Exhibition Hall</a>
				{
					isMember && <>
						<a href="/exploration-zone" title="ISF Exploration Zone">ISF Exploration Zone</a>
						<a href="/speaker-gallery" title="Speaker Gallery">Speaker Gallery</a>
					</>
				}
				<a href="/sponsor-theatre" title="Sponsor Theatre">Sponsor Theatre</a>
			</div>
		</div>
		{
			isMember &&  <>
				<div class="dropdowntk2">
					<button class="dropbtntk2">Directories
						<i class="fa fa-caret-down" />
					</button>
					<div class="dropdown-contenttk2">
					<a href="https://isfcongress.tkeventsregistration.com/digital2021/attendeedirectory" title="Attendee Directory">Attendee Directory</a>
					<a href="https://isfcongress.tkeventsregistration.com/digital2021/speakerdirectory" title="Speaker Directory">Speaker Directory</a>
					<a href="https://isfcongress.tkeventsregistration.com/digital2021/sponsordirectory" title="Sponsor Directory">Sponsor Directory</a>
					</div>
				</div>
				{ new Date() > new Date("2021-10-26 09:00+01:00") && <a href="https://isfcongress.tkeventsregistration.com/digital2021/ondemand" target="_blank" title="Atrium">On-Demand</a>}
			</>
		}
	</div>
</div>
